<template>
	<p-data-table
		:value="productData"
		ref="team_product_data_table"
		data-key="product_id"
		class="team-product-data-table"
		scrollable
		v-model:expandedRows="localExpandedRows"
	>
		<template #empty>
			<div class="dim">No Data</div>
		</template>
		<p-column expander style="width: 1em" class="product-row-expander" />
		<p-column header="Team">
			<template #body="row">
				<strong>{{ row.data.product_name }}</strong>
			</template>
		</p-column>
		<p-column header="Spend" class="column-align-right">
			<template #body="row">
				{{ currency(row.data.spend, 0) }}<br />
				<div class="sub-value" v-html="trend(row.data.spend, row.data.compare_spend)" />
			</template>
		</p-column>
		<p-column header="Purchases" class="column-align-right">
			<template #body="row">
				{{ numberFormat(row.data.purchases) }}<br />
				<div class="sub-value" v-html="trend(row.data.purchases, row.data.compare_purchases)" />
			</template>
		</p-column>
		<p-column header="RPL" class="column-align-right">
			<template #body="row">
				{{ currency(row.data.rpl) }}<br />
				<div class="sub-value" v-html="trend(row.data.rpl, row.data.compare_rpl)" />
			</template>
		</p-column>
		<p-column header="Active Accounts" class="column-align-right">
			<template #body="row">
				{{ numberFormat(row.data.active_accounts) }}<br />
				<div class="sub-value" v-html="trend(row.data.active_accounts, row.data.compare_active_accounts)" />
			</template>
		</p-column>
		<p-column header="Spend/Account" class="column-align-right">
			<template #body="row">
				{{ currency(row.data.spa) }}<br />
				<div class="sub-value" v-html="trend(row.data.spa, row.data.compare_spa)" />
			</template>
		</p-column>
		<template #expansion="productData">
			<user-sub-table :team-id="teamId" :user-data="productData.data.user_data" />
		</template>
	</p-data-table>
</template>

<script>
import { currency, numberFormat, trend } from '@/lib/Filters';
import userSubTable from './UserSubTable.vue';

export default {
	name: 'SalesPerformanceTable_ProductSubTable',
	components: {
		userSubTable,
	},
	emits: ['update:expandedRows'],
	props: {
		teamId: String,
		productData: {
			type: Array,
			default() {
				return [];
			},
		},
		expandedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	computed: {
		localExpandedRows: {
			get() {
				return this.expandedRows;
			},
			set(new_value) {
				this.$emit('update:expandedRows', new_value);
			},
		},
	},
	methods: {
		currency,
		numberFormat,
		trend,
	},
};
</script>
